'use client';

import React from "react";

const img1 = "/assets/dcc/dcc.png";
function Hero() {
  return (
    <>
      <div className="flex flex-col xl:flex-row items-start mt-4 sm:mt-[10vh] mb-32 max-w-7xl px-3 sm:px-6 xl:px-10 mx-auto ">
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-[56px] items-center">
          <div className="max-w-[634px] flex flex-col gap-4 lg:gap-8 order-2">
            <h1 className="text-3xl sm:text-4xl lg:text-6xl font-semibold leading-tight">
              Digital <br /> Command <br /> Center
            </h1>
            <p className="font-medium text-lg sm:text-xl lg:text-2xl text-[#808080]">
              Your All-In-One Solution For HR, CRM, Project Management, ERP and
              end-to-end solutions for corporate management.
            </p>

            <div>
              <a
                className="px-6 py-2 text-nowrap justify-center items-center inline-flex gap-3 z-10 transition-all duration-300 cursor-pointer text-color-100 font-medium bg-[linear-gradient(180deg,_var(--accent-light),_var(--accent-dark))] rounded-lg hover:shadow-[0px_0px_10px_2px_var(--accent-transparent-1)]"
                href={"https://digitalcommandcenter.io/"}
                target="_blank"
              >
                Go to digitalcommandcenter.io
              </a>
            </div>
          </div>
          <div className="relative w-full max-w-[744px] lg:h-[360px] order-1 lg:order-3">
            <img
              src={img1}
              alt="Dashboard Preview"
              className="w-full h-full object-cover object-left-top rounded-2xl border border-color-97"
            />
          </div>
        </div>
      </div>

      <div className="absolute top-32 -left-80 rounded-full w-[450px] h-[450px] bg-[radial-gradient(circle,_var(--accent-light),_var(--accent-dark))] blur-3xl opacity-10 z-20"></div>
      <div className="absolute top-32 -right-80 rounded-full w-[450px] h-[450px] bg-[radial-gradient(circle,_var(--accent-light),_var(--accent-dark))] blur-3xl opacity-10 z-20"></div>
    </>
  );
}

export default Hero;
